// extracted by mini-css-extract-plugin
export default {"ReplyButton":"qa_a big_wx big_jb big_xl big_i big_j big_q big_vt big_et big_so big_sp big_eg","ReplyButton__icon":"qa_b big_rz"};